import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import { useStories } from '../../hooks'
import { useActions, useApplicationName } from '../../store'
import { propTypes } from '../../helpers'
import { AllStoriesView } from './AllStoriesView'
import { SingleStoryView } from './SingleStoryView'

const StoryPage = ({ category }) => {
  const { id } = useParams()
  const { stories } = useStories(category.id)
  const applicationName = useApplicationName()
  const { setError } = useActions()
  const [selectedStory, setSelectedStory] = useState(null)

  useEffect(() => {
    if (id === 'new') {
      setSelectedStory({
        id: null,
        categoryId: category.id,
        title: '',
        content: ''
      })
    } else if (stories && id) {
      const story = stories.find((it) => it.id === Number(id))
      if (story) {
        setSelectedStory(story)
      } else {
        setSelectedStory(null)
        setError('Story not found')
      }
    } else {
      setSelectedStory(null)
    }
  }, [id, stories, category.id, setError])

  return (
    <Container className='resizing-container' fluid={!selectedStory}>
      <Helmet>
        <title>
          {category.name} - {applicationName}
        </title>
      </Helmet>
      {stories ? (
        selectedStory ? (
          <SingleStoryView category={category} story={selectedStory} />
        ) : (
          <AllStoriesView category={category} stories={stories} />
        )
      ) : null}
    </Container>
  )
}

StoryPage.propTypes = { category: propTypes.categoryPropType }
export { StoryPage }
